import { Dropdown, SidebarGroups } from './Dropdown'
import { Group } from './Group'
import { GroupHeader } from './GroupHeader'
import { GroupItem } from './GroupItem'

export const NavigationDropdown = {
  Dropdown,
  Group,
  GroupHeader,
  GroupItem,
  SidebarGroups,
}
